export const getColorCode = (code: string | undefined): string => {
  switch (code) {
    case "orange":
      return "#FF4C00";
    case "black":
      return "#3B393F";
    case "green":
      return "#0E920E";
    case "lightgrey":
      return "#3B393F";
    case "blue":
      return "#106EDC";
    case "purple":
      return "#9631CA";
    default:
      return "#3B393F";
  }
};
